import React from 'react';
import {useQuery} from '@apollo/client';
import Icon from '../../components/Icon';
import {QUERY_STUDY_LIST} from '../Study/graphql';
import {QUERY_USER} from '../Client/graphql';

const LEVELS = {
  0: {name: 'times', color: 'danger'},
  1: {name: 'dot-circle', color: 'primary'},
  2: {name: 'check', color: 'success'},
  3: {name: 'lock', color: 'secondary'},
};

const PlanStudy = ({levels, notAbsolute}) => {
  const {user} = useQuery(QUERY_USER).data;
  const {studyList} = useQuery(QUERY_STUDY_LIST).data || {studyList: []};

  const getStudyStatus = level => {
    const study = studyList.find(x => x.lesson.level === level);

    if (study) {
      if (study.intermediatePassed === false) {
        return 0;
      }

      const {vocabularyPassed, trialPassed, finalPassed, phoneticsPassed} = study;

      if (vocabularyPassed && trialPassed && finalPassed && phoneticsPassed) {
        return 2;
      }

      if (user.client.currentLevel === level) {
        return 1;
      }
    }

    return 3;
  };

  const isPassed = levels => {
    let passedCount = 0;
    for (let i in levels) {
      const study = studyList.find(x => x.lesson.level === levels[i]);
      const {vocabularyPassed, trialPassed, finalPassed, phoneticsPassed} = study || {};
      const isPassed = vocabularyPassed && trialPassed && finalPassed && phoneticsPassed;
      if (isPassed) {
        passedCount += 1;
      }
    }
    return levels.length === passedCount;
  };

  // const studyStatuses = levels.map(x => getStudyStatus(x));
  // const min = Math.min(...studyStatuses);

  if (!studyList.length) return null;

  return (
    <div className={!notAbsolute && 'position-absolute'} style={{left: 10, top: 10}}>
      {/* <Icon name={LEVELS[min].name} color={LEVELS[min].color} /> */}
      {isPassed(levels) && <Icon name="check" color="success" />}
    </div>
  );
};

export default PlanStudy;
